import { FormSelect } from '@systemeio/ui'
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper'
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface'
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import { TriggerCampaignEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface'
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data'
import { getCampaignStepsListNextjsUrl } from 'modules/campaigns/campaign-steps/utils/get-campaign-steps-list-nextjs-url'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { OpenInNewIcon } from '@systemeio/ui'

interface TriggerCampaignItemProps extends EditTriggerItemInterface<TriggerCampaignEditInterface> {}

const TriggerCampaignItem = ({
  triggers,
  trigger,
  idx,
  errors,
  onDelete,
  setRules,
  isStatic,
}: TriggerCampaignItemProps) => {
  const { t } = useLocoTranslation()
  return (
    <EditTriggerWrapper trigger={trigger} onDelete={() => onDelete(idx)}>
      {({ data, renderTriggerLabel, onOpen }) => (
        <>
          <FormSelect
            disabled={isStatic}
            onOpen={() => onOpen(AutomationRuleTriggersDataEnum.campaign_completed)}
            label={renderTriggerLabel({
              label: t('dashboard.campaign.title'),
              additionalLabel: trigger.campaign.id ? (
                <LinkWithoutPrefetch
                  rel="noreferrer"
                  target={'_blank'}
                  className={`group self-center outline-hidden`}
                  href={getCampaignStepsListNextjsUrl(trigger.campaign.id)}
                >
                  <OpenInNewIcon
                    className={
                      'main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary'
                    }
                  />
                </LinkWithoutPrefetch>
              ) : undefined,
            })}
            placeholder={t('dashboard.automation_rule.choose_campaign')}
            value={trigger.campaign.id}
            staticData={getDataFromObj(trigger.campaign)}
            data={data.campaignData}
            onChange={data =>
              setRules(prev => {
                return {
                  ...prev,
                  triggers: triggers.map((el, i) => {
                    if (idx === i) {
                      return {
                        ...el,
                        campaign: { id: data },
                      }
                    } else {
                      return el
                    }
                  }),
                }
              })
            }
            error={errors.automationTriggers[trigger.id]?.campaign?.join('')}
          />
        </>
      )}
    </EditTriggerWrapper>
  )
}

export default TriggerCampaignItem
